import { PRODUCT_BY_ID, type ProductId } from '@/config/products';
import { getProductIconComponent } from '@/config/productIcons';

interface ProductTagChipProps {
  productId: ProductId;
  size?: 'sm' | 'md';
  showIcon?: boolean;
  faded?: boolean;
  className?: string;
}

export default function ProductTagChip({
  productId,
  size = 'md',
  showIcon = true,
  faded = false,
  className = '',
}: ProductTagChipProps) {
  const product = PRODUCT_BY_ID[productId];
  const Icon = getProductIconComponent(product.iconKey);

  return (
    <span
      className={`product-tag-chip product-tag-chip--${size} ${product.tagClass} ${
        faded ? 'product-tag-chip--faded' : ''
      } ${className}`}
    >
      {showIcon && <Icon className={size === 'sm' ? 'h-2 w-2' : 'h-2.5 w-2.5'} />}
      {product.shortName}
    </span>
  );
}
